import { URL_CONST } from 'utils/urlConsts'

// Company-data refresh must also run on Scan Back Overview. That route sits
// outside /irontraps/incidents, but the Scan Back Incidents tab badge is fed
// by this list's scanBackCount.
export const isIncidentsListOnScreen = (href = '') =>
  href.indexOf(URL_CONST.incidents.incidents) !== -1 ||
  href.indexOf(URL_CONST.incidents.scanbackOverview) !== -1
